window.GetInventoryData = function(wrapper){
  const panel = wrapper.querySelector('.inventory-panel');
  const variantId = wrapper.getAttribute('data-variant');

  if (wrapper.closest('.single-product-page')) {
    wrapper.classList.add('active');
  }

  if (wrapper.classList.contains('loaded') || wrapper.classList.contains('fetching-inventory')) return;

  wrapper.classList.add('fetching-inventory');
  panel.querySelector('.inventory-loader').style.display = 'block';

  const params = new URLSearchParams({
    api: 'inventory-bulk',
    variants: variantId,
    shop: (window.Shopify && window.Shopify.shop) || '',
  });

  fetch(`/apps/customer-create?${params.toString()}`)
    .then(res => res.json())
    .then(inventoryData => {
      wrapper.classList.remove('fetching-inventory');

      const entries = inventoryData[variantId] || [];

      const usEntry = entries.find(e => e['US Warehouse'] !== undefined);
      const caEntry = entries.find(e => e['Canada Warehouse'] !== undefined);
      const usIsAvailable = usEntry && usEntry['is_available'] === true && Number(usEntry['US Warehouse']) > 0;
      const caIsAvailable = caEntry && caEntry['is_available'] === true && Number(caEntry['Canada Warehouse']) > 0;

      const isDistributor = wrapper.getAttribute('data-is-distributor') === 'true';
      const isProductPage = wrapper.closest('.single-product-page') !== null;

      let usQty = usIsAvailable ? usEntry['US Warehouse'] + ' pcs' : 'Out of Stock';
      let caQty = caIsAvailable ? caEntry['Canada Warehouse'] + ' pcs' : 'Out of Stock';

      if (isDistributor && isProductPage) {
        if (usIsAvailable && !caIsAvailable) {
          caQty = '4–6 weeks lead time';
        } else if (!usIsAvailable && caIsAvailable) {
          usQty = '4–6 weeks lead time';
        } else if (!usIsAvailable && !caIsAvailable) {
          usQty = '4–6 weeks lead time';
          caQty = '4–6 weeks lead time';
        }
      }

      const usStockEl = panel.querySelector('.us-stock');
      const caStockEl = panel.querySelector('.ca-stock');

      usStockEl.textContent = usQty;
      caStockEl.textContent = caQty;

      if (usIsAvailable) {
        usStockEl.classList.remove('out-of-stock');
        usStockEl.classList.add('in-stock');
      } else {
        usStockEl.classList.remove('in-stock');
        usStockEl.classList.add('out-of-stock');
      }

      if (caIsAvailable) {
        caStockEl.classList.remove('out-of-stock');
        caStockEl.classList.add('in-stock');
      } else {
        caStockEl.classList.remove('in-stock');
        caStockEl.classList.add('out-of-stock');
      }

      // Lead Time logic for Description column
      const row = wrapper.closest('.product-list-content') || wrapper.closest('.product-wrapper') || wrapper.closest('.entry-summary') || wrapper.closest('.product-image-summary') || document;
      const descEl = row ? row.querySelector('.shopify-product-details__short-description') : null;

      if (descEl) {
        let leadTimeEl = descEl.querySelector('.lead-time-message');
        let showLeadTime = false;
        let leadTimeText = '';

        if (isDistributor) {
          if (!usIsAvailable && !caIsAvailable) {
            showLeadTime = true;
            leadTimeText = '4–6 weeks lead time';
          } else if (usIsAvailable && !caIsAvailable) {
            showLeadTime = true;
            leadTimeText = 'Canada Stock - 4–6 weeks lead time';
          } else if (!usIsAvailable && caIsAvailable) {
            showLeadTime = true;
            leadTimeText = 'Chicago, USA Stock - 4–6 weeks lead time';
          }
        }

        if (showLeadTime) {
          if (!leadTimeEl) {
            leadTimeEl = document.createElement('div');
            leadTimeEl.className = 'lead-time-message';
            descEl.appendChild(leadTimeEl);
          }
          leadTimeEl.textContent = leadTimeText;
        } else {
          if (leadTimeEl) {
            leadTimeEl.remove();
          }
        }
      }

      panel.querySelector('.inventory-loader').style.display = 'none';
      panel.querySelector('.inventory-content').style.display = 'block';

      wrapper.classList.add('loaded');
    })
    .catch(err => {
      wrapper.classList.remove('fetching-inventory');
      panel.querySelector('.inventory-loader').textContent = 'Failed to load inventory';
      console.error(err);
    });
}
 
document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.inventory-btn');
  if (!btn) return;

  const wrapper = btn.closest('.inventory-toggle');
  if (wrapper) {
    wrapper.classList.toggle('active');
    window.GetInventoryData(wrapper);
  }
});

// Automatically load inventory for all widgets on page load and handle AJAX page changes
function initAllWidgets() {
  document.querySelectorAll('.inventory-toggle:not(.loaded):not(.fetching-inventory)').forEach(window.GetInventoryData);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllWidgets);
} else {
  initAllWidgets();
}

// Observe DOM for newly added elements (for AJAX pagination, infinite scroll, filtering)
const observer = new MutationObserver((mutations) => {
  let hasNewToggles = false;
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.classList && node.classList.contains('inventory-toggle')) {
          hasNewToggles = true;
          break;
        }
        if (node.querySelector && node.querySelector('.inventory-toggle')) {
          hasNewToggles = true;
          break;
        }
      }
    }
    if (hasNewToggles) break;
  }
  if (hasNewToggles) {
    initAllWidgets();
  }
});

observer.observe(document.body, { childList: true, subtree: true });